import { render, staticRenderFns } from "./submit_list.vue?vue&type=template&id=05a6bbb4&scoped=true"
import script from "./submit_list.vue?vue&type=script&lang=js"
export * from "./submit_list.vue?vue&type=script&lang=js"
import style0 from "./submit_list.vue?vue&type=style&index=0&id=05a6bbb4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a6bbb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05a6bbb4')) {
      api.createRecord('05a6bbb4', component.options)
    } else {
      api.reload('05a6bbb4', component.options)
    }
    module.hot.accept("./submit_list.vue?vue&type=template&id=05a6bbb4&scoped=true", function () {
      api.rerender('05a6bbb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/submit_list.vue"
export default component.exports